<template>
  <span class="field-help">
    <button
      type="button"
      class="field-help__trigger"
      :aria-label="'Qué es ' + label"
      @click.prevent
    >
      <font-awesome-icon icon="info-circle"></font-awesome-icon>
    </button>
    <span class="field-help__bubble" :class="'field-help__bubble--' + align" role="tooltip">{{ text }}</span>
  </span>
</template>

<script>
export default {
  name: "FieldHelp",
  props: {
    // Nombre del campo, sólo para el lector de pantalla
    label: { type: String, required: true },
    text: { type: String, required: true },
    // 'left' (defecto) ancla la burbuja al borde izquierdo del ícono, que es lo que necesitan
    // los formularios de capas: ahí el ícono va pegado a un <label> alineado a la izquierda y
    // centrar la burbuja la sacaba del formulario. 'right' la ancla al borde derecho y la hace
    // crecer hacia la izquierda: es el caso del panel de vista previa, pegado al borde derecho.
    align: { type: String, default: "left" }
  }
};
</script>

<style scoped>
.field-help {
  position: relative;
  display: inline-block;
  margin-left: 6px;
  vertical-align: middle;
}

/* Es un <button> y no un <span> para que entre en el orden de tabulación:
   la burbuja se abre con :focus-within, así que el teclado la alcanza igual que el mouse. */
.field-help__trigger {
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  background: none;
  color: #3c8dbc;
  font-size: 15px;
  line-height: 1;
  cursor: help;
}

.field-help__trigger:focus {
  outline: 2px solid rgba(60, 141, 188, 0.5);
  outline-offset: 2px;
  border-radius: 50%;
}

.field-help__bubble {
  position: absolute;
  top: calc(100% + 6px);
  /* El anclaje horizontal lo ponen los modificadores: centrarla acá la sacaba por la
     izquierda en los formularios, donde el ícono va pegado al borde del contenedor. */
  z-index: 40;
  width: max-content;
  max-width: min(22rem, calc(100vw - 32px));
  padding: 8px 10px;
  border-radius: 4px;
  background: #333;
  color: #fff;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.35;
  text-align: left;
  white-space: normal;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s;
}

.field-help__bubble--left { left: 0; }
.field-help__bubble--right { right: 0; }

.field-help:hover .field-help__bubble,
.field-help:focus-within .field-help__bubble {
  visibility: visible;
  opacity: 1;
}
</style>
